export enum InvestmentCategory {
  UNSET,
  STABILIZED,
  VALUE_ADD,
  VACANT,
}
